module.exports = __webpack_public_path__ + "static/media/icon-copy-blue.ab91b5d0.svg";